<template>
  <router-view/>
</template>

<style src="@/css/fonts.css"></style>
<style src="@/css/global.css"></style>
<style src="@/css/animations.css"></style>
<style src="@/css/foneturk-alert.css"></style>